import { useNavigate, useParams } from "react-router";
import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import CreateForm from "../components/web2lead/CreateForm";
import { AuthContext } from "../context/AuthContext";
import GeneratedHtml from "../components/web2lead/GeneratedHtml";
import backArrow from "../assets/images/webToLead/back-arrow.svg";
import { emptyGeneratedHtml } from "../actionCreator/webToLeadActionCreater";
import { useFormDetails } from "../components/web2lead/hooks/useFormDetails";
import { configType, standardFieldsOptions } from "../constant/WebToLead";
import { getUserInfo } from "../utils/utils";

const CreateLeadForm = ({ isEdit }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const user = getUserInfo();
  const { formDetails, getDetailsById } = useFormDetails(id);
  const { isAuthenticated } = useContext(AuthContext);

  const generatedHtml = useSelector(
    (state) => state.WebToLeadReducer.generatedHtml
  );

  if (!isAuthenticated) {
    navigate("/signin");
  }

  useEffect(() => {
    if (id) {
      getDetailsById(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="d-flex justify-content-center web-to-lead font-roboto padd-90">
      <div className="settings-card" style={{ width: "100%" }}>
        {!generatedHtml ? (
          <CreateForm
            initialValues={
              isEdit && formDetails
                ? {
                    ...formDetails,
                    customFields: formDetails?.webToLeadConfigFields?.filter(
                      (d) => d?.fieldCategory === "custom"
                    ),
                    webToLeadConfigFields: [
                      ...formDetails?.webToLeadConfigFields
                        ?.filter(
                          (d) => d.fieldCategory === "standard" && d.isSelected
                        )
                        ?.map((i) => i?.fieldName),
                    ],
                  }
                : {
                    configType: configType.EMBEDDED_HTML,
                    webToLeadConfigFields: standardFieldsOptions
                      ?.filter((d) => !d?.isOptional)
                      ?.map((d) => d.fieldName),
                    webToLeadConfigCustomFields: [],
                    assignTo: user?.firstName + user?.lastName,
                  }
            }
          />
        ) : (
          <>
            <div
              className="d-flex cursor-pointer align-items-center text-color-1C1C1C roboto-bold heading24px"
              onClick={() => {
                dispatch(emptyGeneratedHtml());
                navigate("/settings/web-to-lead");
              }}
            >
              <img src={backArrow} alt="" style={{ marginRight: "15px" }} /> Web
              to Lead Setup
            </div>
            <GeneratedHtml />
            {/* <div style={{ marginBottom: 80 }}>
                <div
                  className="mt40 d-flex flex-column"
                  style={{ width: "40%" }}
                >
                  <label className="text-color-1C1C1C roboto-medium heading20px">
                    Generated Form link
                  </label>
                  <Input
                    placeholder="domainname.social.com"
                    style={{ height: "60px" }}
                    className="link-input heading20px"
                  />
                  <div className="mt10" style={{ color: "#848484" }}>
                    Use this link for ….
                  </div>
                </div>
              </div> */}
          </>
        )}
      </div>
    </div>
  );
};

export default CreateLeadForm;
